import { Button, CardContent, Drawer, ListItem } from '@mui/material';
import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import Avatar from '@mui/material/Avatar';
import Badge from '@mui/material/Badge';

import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { StyledCard } from '../AccountBasicInfo/AccountBacisInfo.styles';
import CustomDataGrid from '../DataGrid/DataGrid';
import Filters from '../Filters/Filters';
import CustomizedEstimateMenus from '../dropdownbutton/estimateActionMenu';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import { PermissionsEnum } from "../../utils/auth.types";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import Link from '@mui/material/Link';
import { ApiStatus } from "../../utils/api.types";
import { Utils } from "../../utils/common-utils";
import { GridActionsCellItem, GridColDef, GridColumnHeaderParams, GridValueGetterParams } from '@mui/x-data-grid';
import { AInvoice } from '../../utils/invoice.types';
import { AEstimate } from '../../utils/estimate.types';
import { fetchCreditNotes } from '../../store/creditNoteStore/creditNoteThunk';
import moment from 'moment';
import { useNavigate } from "react-router-dom";
// import DialogPaymentSettlementForm from '../DialogPaymentSettlementForm/DialogPaymentSettlementForm';
import DialogRecievePaymentForm from '../DialogPaymentSettlementForm/DialogRecievePaymentForm';
import DialogInvoiceReciepts from '../DialogInvoiceReciepts/DialogInvoiceReciepts';
import Invoice from '../Invoice/Invoice';
import EstimateForm from '../../pages/Estimate/EstimateForm';


interface CreditNoteListProps {
    accountType: string;
    creditNoteId?: string;
    type: string;
}
const CreditNoteFlowData: FC<CreditNoteListProps> = (props) => {
    const dispatch = useAppDispatch();

    // const { invoices, status } = useAppSelector(state => state.invoices);
    const { creditNotes, status } = useAppSelector(state => state.creditNotes);
    const { permissions, selectedAccount } = useAppSelector(state => state.auth);
    const canUpdateAccount = permissions?.includes(PermissionsEnum.Account_Update);

    const navigate = useNavigate();
    const currentPathName = window.location.href;
    const curPage = currentPathName.split('/');
    const [showPaymentButton, setShowPaymentButton] = useState<Boolean>(false);
    const [openSettlementDrawer, setOpenSettlementDrawer] = useState<boolean>(false);
    const [openRecivePaymentDrawer, setOpenRecivePaymentDrawer] = useState<boolean>(false);
    const [openInvoiceRecieptsDrawer, setOpenInvoiceRecieptsDrawer] = useState<boolean>(false);
    const [selectedBuyerId, setSelectedBuyerId] = useState('');
    const [selectedInvoices, setSelectedInvoices] = useState<AEstimate[]>([]);
    const [filters, setFilters] = useState('');
    const [isRefersh, setIsRefersh] = useState(false);

    // Handle estimate button
    const handleAddCreditNote = () => {
        const navLink = `/sales/credit-note/create`;
        navigate(navLink);
    };
    const handleAddDebitNote = () => {
        const navLink = `/sales/debit-note/create`;
        navigate(navLink);
    };

    /**
    * Handler for account name click.
    */
    const handleInvoiceNoClick = useCallback(({ _id, status, pdfTemplate }: AEstimate) => {
        // Call edit function
        let navLink = '';
        let type = '';
        if (curPage.includes('account-payable')) {
            type = 'AP';
        } else {
            type = 'AR';
        }
        if (status === 'DRAFT') {
            navLink = `/sales/credit-note/edit/${_id}`;
        } else {
            // navLink = `/sales/credit-note/${_id}/view?templateId=${pdfTemplate}&type=${type}`;
            navLink = '';
        }
        navigate(navLink);
    }, []);

    const filterOnChangeHandler = (data: any) => {
        console.log("filter date from invoice listing ===== ", data);
        setFilters(data);
    };

    const TabHeading = (props.accountType == "Invoices") ? "" : `${props.accountType} Cash Summary`;

    /**
      * Fetch all the accounts on Accounts page load.
    */
    useEffect(() => {
        // setSelectedInvoices([]);
        if (filters) {
            const { _id: id } = selectedAccount;
            dispatch(fetchCreditNotes({ accountId: id, type: props.type, params: filters }));
        }
        setIsRefersh(true);
    }, [dispatch, selectedAccount, filters, isRefersh]);

    const actionChangeHandler =(data:any) => {
        setIsRefersh(data.isRefersh)
    }

    /** 
    * Column defs for account list data grid.
    */
    const columns: GridColDef[] = useMemo(() => {
        let gridCols = [
            {
                field: "invoiceNumber",
                headerName: '#Invoice No/Date',
                type: "string",
                flex: 2,
                renderCell: ({ row, value }: GridValueGetterParams) => {

                    // let docNumber = value;
                    // if (row.invoiceNumber != undefined) {
                    //     docNumber = row.invoiceNumber || '';
                    // }
                    // else if (row.estimateNumber ! = undefined) {
                    //     docNumber = row.estimateNumber.toString() || '';
                    // }
                    // console.log(docNumber);
                    // // console.log(value);
                    
                    return(<>
                        <Typography
                            sx={{ cursor: 'pointer', fontWeight: 'bold'}}
                            component={Link}
                            underline='hover'
                            color={'primary'}
                            style={{color: "#09b2ee"}}
                            onClick={() => handleInvoiceNoClick(row)}
                        >
                            {row.invoiceType || row.voucherType} #{ row.estimateNumber != undefined ? row.estimateNumber : row.invoiceNumber} ({ 
                                row.date != undefined && row.date != '' ? 
                                moment(row.date).format("DD/MM/YYYY") : moment(row.createDate).format("DD/MM/YYYY")
                            } )
                        </Typography>
                        <Tooltip title={row.client.name}>
                            <Typography onClick={() => handleInvoiceNoClick(row)}>
                                {row.client.name}
                            </Typography>
                        </Tooltip>
                    </>
                    )
                }
            },
            // {
            //     field: "invoiceType",
            //     headerName: 'Type',
            //     type: "string",
            //     flex: 1,
            //     renderCell: ({ row, value }: GridValueGetterParams) => (
            //         <Typography>{row.invoiceType}</Typography>
            //     )
            // },
            // {
            //     field: "buyer",
            //     headerName: 'Customer',
            //     type: "string",
            //     flex: 1,
            //     renderCell: ({ row, value }: GridValueGetterParams) => {
                    
            //         let customer = value;
            //         if (props.type === 'account-receivable') {
            //             if (row.invoiceAccountRelation === 'AP') {
            //                 // showing invoices that are created by others for the logged-in user.
            //                 customer = row.account;
            //             }
            //         }

            //         return (<>
            //             <Tooltip title={customer?.name}>
            //                 <Typography >
            //                     {customer?.name}
            //                 </Typography>
            //             </Tooltip>
            //         </>)
            //     }
            // },
            {
                field: "lineItems",
                headerName: 'Amount',
                type: "string",
                flex: 1,
                // cellClassName: () => {
                //     return 'text-center'
                // },
                renderHeader: (params: GridColumnHeaderParams) => (
                    <span style={{ flex: 'auto', textAlign: 'right' }} className="header-flex-end">Amount</span>
                ),
                renderCell: ({ row, value }: GridValueGetterParams) => {
                    return (<>
                        <Typography className='flex-end' >
                            { row.principalAmount != undefined ? 
                                Utils.formatNumber(row.principalAmount || 0, true, true) :
                                Utils.formatNumber(row.amount || 0, true, true)}
                        </Typography>
                    </>);
                }
            },
            {
                field: "tax",
                headerName: 'Tax',
                type: "string",
                flex: 1,
                renderHeader: (params: GridColumnHeaderParams) => (
                    <span style={{ flex: 'auto', textAlign: 'right' }} className="header-flex-end">Tax</span>
                ),
                renderCell: ({ row, value }: GridValueGetterParams) => {
                    return (<>
                        <Typography className='flex-end' >
                            {Utils.formatNumber(parseFloat(row.tax1) + parseFloat(row.tax2) + parseFloat(row.tax3) || '0', true, true)}
                        </Typography>
                        <span className='flex-end' style={{fontSize: '11px'}}>@{row.tax1Percent > 0 ? row.tax1Percent : '0'}%</span>
                    </>);
                }
            },
            {
                field: "amount",
                headerName: 'Total',
                type: "string",
                flex: 1,
                renderHeader: (params: GridColumnHeaderParams) => (
                    <span style={{ flex: 'auto', textAlign: 'right' }} className="header-flex-end">Total</span>
                ),
                renderCell: ({ row, value }: GridValueGetterParams) => {
                    return (<>

                        <Typography className='flex-end' >
                            {Utils.formatNumber(parseFloat(row.amount).toFixed(2) || '0')}
                        </Typography>

                    </>);
                }
            },
            {
                field: "openingBalance",
                headerName: 'Opening Balance',
                type: "string",
                flex: 1,
                renderHeader: (params: GridColumnHeaderParams) => (
                    <span style={{ flex: 'auto', textAlign: 'right' }} className="header-flex-end">Balance</span>
                ),
                renderCell: ({ row, value }: GridValueGetterParams) => {
                    return (<>

                        <Typography className='flex-end' >
                            
                            { (row.openingBalance >=0 || row.openingBalance <= 0 ) ? 
                                Utils.formatNumber(parseFloat(row.openingBalance).toFixed(2) || '0') : 
                                '-'
                            }
                        </Typography>

                    </>);
                }
            },
            {
                field: "status",
                headerName: 'Status',
                type: "string",
                flex: 1,
                renderCell: ({ row, value }: GridValueGetterParams) => {
                    return (<>
                        { row.status == 'DRAFT' &&
                            <ListItem>
                                <Badge color="secondary" badgeContent={row.status} style={{padding: "10px 10px 0px 5px"}}></Badge>
                            </ListItem>
                        }
                        { row.status == 'PENDING' &&
                            <ListItem>
                                <Tooltip title={row.status} color="warning">
                                    <Badge color="warning" badgeContent={row.status} style={{padding: "10px 10px 0px 5px"}}></Badge>
                                </Tooltip>
                            </ListItem>
                        }
                        { row.status == 'PARTIALLY_PAID' &&
                            <ListItem>
                                <Badge color="info" badgeContent={row.status} style={{padding: "10px 10px 0px 5px"}}></Badge>
                                
                            </ListItem>
                        }
                        { row.status == 'PAID' &&
                            <ListItem>
                                <Badge color="success" badgeContent={row.status} style={{padding: "10px 10px 0px 5px"}}></Badge>
                            </ListItem>
                        }
                        { row.status == 'OVER_PAID' &&
                            <ListItem>
                                <Badge color="primary" badgeContent={row.status} style={{padding: "10px 10px 0px 5px"}}></Badge>
                            </ListItem>
                        }
                        
                    </>);
                }
            },
            {
                field: "action",
                headerName: 'Action',
                type: "string",
                flex: 1,
                renderCell: ({ row, value }: GridValueGetterParams) => {
                    return (
                        <CustomizedEstimateMenus type={props.type} row={row} actionChangeHandler={actionChangeHandler}/>
                    );
                }
            }
        ];
        
        return gridCols;
    }, [handleInvoiceNoClick]);

    return (
        <>
            {(props.accountType == "Invoices") ? "" :
                <StyledCard>
                    <CardContent>
                        <Typography className={'cardHeader'} variant="h4" component="div">
                            <Box>Business Summary</Box>
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ 'color': '#8c8c8c', 'fontWeight': '400', 'fontSize': '14px', 'padding': '22px;' }} component="div">
                            (volume+amount with % up/down)<br />
                            Total <br />
                            This Month<br />
                            This Week
                        </Typography>
                    </CardContent>
                </StyledCard>
            }
            <StyledCard sx={{ height: 'calc(100vh - 325px)', marginTop: '-10px', marginLeft: '-8px' }}>
                <CardContent >
                    <Typography className={'cardHeader'} variant="h4" component="div">
                        <Box sx={{ display: "flex", justifyContent: "end", paddingTop: '8px', width: '100%' }}>
                            <div style={{ display: "flex", flexDirection: 'row', justifyContent: 'flex-start', flex: 1, alignItems: "flex-start", textAlign: "start" }}>
                                {TabHeading}
                                <Filters type={'account-receivable'} filterHandler={filterOnChangeHandler} />
                            </div>
                            {(props.accountType == "Invoicesss") ?
                                <div style={{ display: "flex", flexDirection: 'row', justifyContent: 'flex-end', clear: "both" }}>
                                    
                                    <Button
                                        startIcon={<AddIcon />}
                                        variant="contained"
                                        color='primary'
                                        onClick={handleAddCreditNote}
                                        style={{ fontSize: '14px', width: '158px', height: '35px', marginLeft: '15px', alignSelf: 'right' }}
                                    >
                                        New Credit Note
                                    </Button>
                                    <Button
                                        startIcon={<AddIcon />}
                                        variant="contained"
                                        color='primary'
                                        onClick={handleAddDebitNote}
                                        style={{ fontSize: '14px', width: '158px', height: '35px', marginLeft: '15px', alignSelf: 'right' }}
                                    >
                                        New Debit Note
                                    </Button>
                                </div>
                                : ""}

                        </Box>
                       
                    </Typography>
                    <div style={{ minHeight: '700px', height: 'calc(100% - 80px)', width: '100%' }}>
                        {/* <Drawer
                            disableEscapeKeyDown={false}
                            anchor="right"
                            onClose={handleCloseCreateEstimateDrawer}
                            open={openRecivePaymentDrawer}>
                            <EstimateForm type={'sale-estimate'} />
                        </Drawer> */}
                        {/* // slots={{ toolbar: GridToolbar }} */}

                        <CustomDataGrid
                            //isRowSelectable={(params: any) =>
                            //    params.row.status != 'DRAFT' && params.row.status != 'PAID'}

                            // onSelectionModelChange={(ids) => onRowsSelectionHandler(ids)}
                            // checkboxSelection={props.type == 'account-receivable'}
                            columns={columns}
                            rows={creditNotes}
                            getRowId={(row) => row._id}
                            loading={status === ApiStatus.LOADING} />
                    </div>
                </CardContent>
            </StyledCard>
        </>
    );
}
export default CreditNoteFlowData;

function openAccountGrid(accType: string) {
    //throw new Error('Function not implemented.');
    alert('Show ' + accType + ' payments');
}
